import { CoreState } from '@app/store/core/states';
import { NotificationState } from './notification.state';
import { AppSettingState } from './app-setting.state';
import { LikeState } from './like.state';
import { FollowState } from './follow.state';
import { CommentState } from './comment.state';

export interface SharedFeatureState {
    notification: NotificationState,
    appSetting: AppSettingState,
    like: LikeState,
    follow: FollowState,
    comment: CommentState
}

export interface State extends CoreState {
    shared: SharedFeatureState
}